export default __webpack_public_path__ + "static/strivee_logo.b23e819e.svg";